import {
  MONTHLY_PLAN_MIN,
  MONTHLY_PLAN_MIN_NEW,
  FIRST_INVESTMENT_MIN,
  FIRST_INVESTMENT_MIN_NEW,
  FIRST_INVESTMENT_MAX,
  MONTHLY_PLAN_MAX,
} from './types';

export const checkInputsIsValid = (
  monthlyAmount: number,
  startAmount: number,
  hasMoneyMarket: boolean,
): boolean => {
  const minFirstInvestment = hasMoneyMarket ? FIRST_INVESTMENT_MIN_NEW : FIRST_INVESTMENT_MIN;
  const minMonthlyPan = hasMoneyMarket ? MONTHLY_PLAN_MIN_NEW : MONTHLY_PLAN_MIN;

  return (
    (monthlyAmount >= minMonthlyPan || startAmount >= minFirstInvestment) &&
    startAmount <= FIRST_INVESTMENT_MAX &&
    monthlyAmount <= MONTHLY_PLAN_MAX
  );
};
